import { render, staticRenderFns } from "./OrderInfoForm.vue?vue&type=template&id=08b0849a&scoped=true&"
import script from "./OrderInfoForm.vue?vue&type=script&lang=js&"
export * from "./OrderInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoForm.vue?vue&type=style&index=0&id=08b0849a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0849a",
  null
  
)

export default component.exports